import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { LetterRequestCustomer_Activity } from 'src/app/Interface/LetterRequestCustomer_Activity';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivity',
  templateUrl: './LetterRequestCustomerMissionActivity.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivity.component.scss']
})
export class LetterRequestCustomerMissionActivityComponent implements OnInit {

  @Input() inner_Letter_id: number = 0
  @Input() inner_Customer_id: number = 0
  InProccessing: boolean = false

  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  DataList_KarshnasMasol_link: Array<string> = []
  DataList_Activity: Array<LetterRequestCustomer_Activity> = []

  Selection_KarshnasMasol_Id: String = "0"
  Selection_KarshnasMasol_Link: String = "0"
  Selection_KarshnasMasol_Link_Dsc: String = ""
  Selection_Dsc: String = ""
  BaseURlFile = environment.BaseUrl

  constructor(
    private Customer_Service: CustomerService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Read_Karshenash_Masole()
  }


  Read_Karshenash_Masole() {
    this.InProccessing = true
    this.Customer_Service.GetSingle(this.inner_Customer_id).subscribe(
      data => {

        this.InProccessing = false
        this.DataList_KarshnasMasol = data['karshnasMasol']
        this.Selection_KarshnasMasol_Id = "0"
      }
    )
  }

  Read_Karshenash_Link() {
    this.Selection_KarshnasMasol_Link_Dsc = ""
    this.DataList_KarshnasMasol_link = []
    if (this.Selection_KarshnasMasol_Link != "0") {
      this.InProccessing = true
      this.Customer_Service.GetLinkKarshnasMasole(Number(this.Selection_KarshnasMasol_Id),
        Number(this.Selection_KarshnasMasol_Link)).subscribe(
          data => {
            this.InProccessing = false
            this.DataList_KarshnasMasol_link = data
          }
        )
    }

  }

  //#region Image

  file_uploaded_src: Array<string> = []

  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.LetterRequestCustomer_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    this.file_uploaded_src.push(this.UploadImageSrc)
    this.UploadImageSrc = ''
    this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.file_uploaded_src.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion


  OnSubmit() {
    if (this.Selection_KarshnasMasol_Id == "0") {
      this.Alertify_Service.ErrorMessage("کارشناس مسئول را انتخاب نمائید")
    }
    else if (this.Selection_KarshnasMasol_Link_Dsc == "") {
      this.Alertify_Service.ErrorMessage("راه ارتباطی را انتخاب نمائید")
    }
    else if (!this.Selection_Dsc || this.Selection_Dsc.trim().length < 100) {
      this.Alertify_Service.ErrorMessage("خلاصه گفتگو را (حداقل 100 کاراکتر) وارد نمائید.")
    }
    else {
      this.InProccessing = true
      this.LetterRequestCustomer_Service.PostActivity(
        this.inner_Letter_id,
        Number(this.Selection_KarshnasMasol_Id),
        Number(this.Selection_KarshnasMasol_Link),
        this.Selection_KarshnasMasol_Link_Dsc,
        this.Selection_Dsc,
        this.file_uploaded_src).subscribe(
          data => {
            this.InProccessing = false
            if (data['id'] == '-1') {
              this.Alertify_Service.ErrorMessage("مهلت ثبت به پایان رسیده است")
            }
            else {
              this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")


              this.file_uploaded_src = []
              this.Selection_KarshnasMasol_Id = "0"
              this.Selection_KarshnasMasol_Link = "0"
              this.Selection_KarshnasMasol_Link_Dsc = ""
              this.Selection_Dsc = ""
            }
          }, error => {
            // AuthInterceptor owns authentication; feature errors must preserve credentials.
          }
        )
    }
  }


}
